<template>
  <!-- seStaList >>> 招聘岗位列表 by lbj-->
  <div class="page"
       v-show="stalist.length > 0">
    <div v-show="!showinfo"
         class="pageson">
      <div class="hasBackG"
           :style="{
          background: 'url(/img/topbanner.png) no-repeat',
          backgroundSize: '100% 100%'
        }">
        <!-- <div class="register_title">岗位选择</div> -->
        <div class="register_title"></div>
        <!-- background="linear-gradient(to bottom,#1a8afa,#97C0FC)" -->
        <van-search v-model="value"
                    shape="round"
                    placeholder="请输入搜索关键词"
                    input-align="center" />
      </div>
      <van-tabs v-model="tabActive"
                sticky
                color="#3A8BFD"
                background="linear-gradient(to bottom, #97c0fc, #f5f6fa)">
        <van-tab v-for="(item, idx) in groupList"
                 :key="idx"
                 :title="item.name"
                 :name="item.name">
        </van-tab>
      </van-tabs>
      <div class="job_content">
        <div class="job_box"
             v-for="(sta, i) in checkedAry"
             :key="i"
             @click="showSta(sta)">
          <div class="job_head">
            <div class="staname">
              {{ sta.staname }}
              <template v-if="sta.deptname"> ({{ sta.deptname }}) </template>
            </div>
            <div class="payface">
              <span v-if="sta.payface">面议</span>
              <span v-else-if="!sta.min_pay"></span>
              <span v-else>{{ sta.min_pay }}~{{ sta.max_pay }}</span>
            </div>
          </div>
          <div class="job_body">
            <div v-if="sta.fulldeptname"
                 class="fulldeptname">{{sta.fulldeptname}}</div>
            <div class="tg">
              <span v-if="sta.workplace">{{ sta.workplace }}</span>
              <!-- <span v-if="sta.boolean ">不限</span>
                <span else="sta.payface">{{ sta.min_age }}-{{ sta.max_age }}岁</span>-->
              <span v-if="sta.workyears">{{ sta.workyears }}</span>
              <span v-if="sta.degree">{{ sta.degree }}</span>
            </div>
          </div>
          <div class="job_foot">
            <div class="fulladdr">{{ sta.fulladdr }}</div>
            <div class="effectbd">{{ sta.effectbd }}</div>
          </div>
        </div>
      </div>

      <!-- <div :class="`Sed bton op`" @click="choose">直接投递</div> -->
    </div>
    <div v-show="showinfo"
         class="pageson gbg">
      <van-nav-bar class="detail_title"
                   :title="title"
                   left-arrow
                   @click-left="closeSta" />
      <div class="info_box">
        <div class="job-detail-header">
          <div class="outside_box">
            <div class="staname_box">
              <div class="staname">{{ sta.staname }}</div>
              <div class="pay">{{ sta.min_pay }}~{{ sta.max_pay }}</div>
            </div>
            <div class="deptname_box">
              <van-icon name="notes-o" />
              <div class="deptname">{{ sta.deptname }}</div>
              <van-icon name="user-o" />
              <div v-if="sta.isrg">若干</div>
              <div v-else>{{ sta.reqnum }}</div>
            </div>
            <div class="stop_time_box">
              截止时间：
              <span class="time_sp">{{ sta.effectbd }} - {{ sta.effected }}</span>
            </div>
          </div>
        </div>
        <div class="job_Description">
          <div class="ch">职位描述</div>
          <div class="title">工作职责：</div>
          <div class="gzzz"
               v-html="sta.gzzz ? sta.gzzz.replace(/\\n/g, '<br/>') : ''"></div>
          <!-- <pre id="gzzz">{{ sta.gzzz }}</pre> -->
          <div class="title">任职资格：</div>
          <div class="rzzg"
               v-html="sta.rzzg ? sta.rzzg.replace(/\\n/g, '<br/>') : ''"></div>
        </div>
        <div class="job_location">
          <div class="workplace">
            <van-icon name="location-o" />
            {{ sta.workplace }}
          </div>
          <div class="fulladdr">{{ sta.fulladdr }}</div>
        </div>
      </div>
      <div :class="`Sed op`"
           @click="b4choose(sta)">
        <div>投递简历</div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vant/lib/search/style'
import { Search } from 'vant'
import { parseTime } from '@/utils'
import {
  getReqStationList,
  checkWxRsInputStatus,
  getQsTemplateOptionList,
  getIvTestPaperInfo,
  checkZpTestRes,
  getScanTestPaperInfo,
  checkScanEntryByStationId
} from '@/request/api.js'
import { Base64 } from 'js-base64'
export default {
  components: {
    'van-search': Search
  },
  data () {
    return {
      moduleNo: null,
      restype: null,
      tj_empid: null,
      zpacid: null,
      tel: null,
      istest: null,
      mode: true,
      m_attachfilepath: null,
      m_autoid: null,
      nowdate: parseTime(new Date(), '{y}-{m}-{d}'),
      stalist: [],
      value: '',
      data: [],
      sta: {},
      showinfo: false,
      title: '岗位描述',
      groupList: [], // 分组后的数据
      tabActive: '',
      checkedAry: [], // 选择tab的数据
      test_before_post: true, // 默认提交前填写问卷
      get_autoid_by_stationid: false // 投递不同岗位需要生成不同的简历记录
    }
  },
  watch: {
    tabActive (n) {
      this.getTabList(n)
    },
    // 搜索
    value (n) {
      this.onSearch(n)
    }
  },
  created () {
    const test_before_post = window['m' + this.moduleNo]
      ? window['m' + this.moduleNo].test_before_post
      : 1
    if (test_before_post == 1)
    {
      this.test_before_post = true
    } else
    {
      this.test_before_post = false
    }
    const get_autoid_by_stationid = window['m' + this.moduleNo]
      ? window['m' + this.moduleNo].get_autoid_by_stationid
      : 1
    if (get_autoid_by_stationid == 1)
    {
      this.get_autoid_by_stationid = true
    } else
    {
      this.get_autoid_by_stationid = false
    }

    // 获取路由带来的参数
    let params = this.$route.query.param || {}
    if (Object.keys(params).length > 0)
    {
      params = JSON.parse(Base64.decode(params))
    }
    this.moduleNo = params.module
    this.restype = params.restype
    this.tj_empid = params.tj_empid || ''
    this.zpacid = params.zpacid || ''
    this.tel = params.tel
    this.istest = params.istest
    this.m_attachfilepath = params.attachfilepath
    this.m_autoid = params.autoid
    this.mode = params.mode


    window.seStaList = this
    this.getReqStationList()
  },
  methods: {
    // 根据tab的ActiveName来筛选数据
    getTabList (name) {
      if (name)
      {
        this.groupList.forEach(ele => {
          if (name == ele.name)
          {
            this.checkedAry = ele.origin
          }
        })
      } else
      {
        this.checkedAry = []
      }
    },
    // 用于分组
    changeGroupData (ary, groupName) {
      let initList = []
      let Groups = []
      initList = ary
      let tempArr = []
      if (initList.length > 0)
      {
        for (let i = 0; i < initList.length; i++)
        {
          if (tempArr.indexOf(initList[i][groupName]) === -1)
          {
            Groups.push({
              name: initList[i][groupName],
              origin: [initList[i]]
              // checkList: [],
              // selectstatus: false
            })
            tempArr.push(initList[i][groupName])
          } else
          {
            for (let j = 0; j < Groups.length; j++)
            {
              if (Groups[j].name == initList[i][groupName])
              {
                Groups[j].origin.push(initList[i])
                break
              }
            }
          }
        }
      }
      // if (Groups.length > 0)
      // {
      //   Groups.forEach(ele => {
      //     ele.total = ele.origin.length
      //   })
      // }
      return Groups
    },
    getReqStationList () {
      //获取岗位列表
      // this.loading = true
      getReqStationList({ zpacid: this.zpacid, moduleno: this.moduleNo || 0 })
        .then(res => {
          this.data = res.data
          if (res.data.length == 0)
          {
            // 没有岗位则直接简历投递 
            const param = {
              module: this.moduleNo,
              zpacid: this.zpacid,
              tel: this.tel,
              attachfilepath: this.m_attachfilepath,
              autoid: this.m_autoid,
              restype: this.restype,
              tj_empid: this.tj_empid,
              mode: this.mode,
            }
            this.$router.push({
              path: "/seForm",
              query: { param: Base64.encode(JSON.stringify(param)) }
            })
          }
          this.stalist = res.data.filter(e => {
            return true
          })
          this.groupList = this.changeGroupData(this.stalist, 'rctype')
        }).finally(() => {
          // this.loading = false
        })
    },
    showSta (sta) {
      this.showinfo = true
      this.sta = sta
    },
    closeSta () {
      this.showinfo = false
    },
    // 投递不同岗位需要生成不同的简历记录
    b4choose (sta) {
      if (this.get_autoid_by_stationid)
      {
        checkScanEntryByStationId({
          stationid: sta.stationid,
          telephone: this.tel, //'admin'
          reqautoid: sta.autoid
        }).then(res => {
          // {autoid: 1743, istest: false, attachfilepath: "AttachFile"}
          if (res.data.length > 0)
          {
            this.m_attachfilepath = res.data[0].attachfilepath
            this.istest = res.data[0].istest
            this.m_autoid = res.data[0].autoid
          }
          this.choose(sta)
        })
      } else
      {
        this.choose(sta)
      }
    },
    choose (sta) {
      //投递简历之前应该判断是否有问卷调查的数据，如果有则需要填完调查表再进行跳转，如果没有则可以直接跳转
      const station = sta
      sessionStorage.setItem('station', JSON.stringify(station))
      sessionStorage.setItem('tj_empid', this.tj_empid)
      sessionStorage.setItem('istest', this.istest)
      sessionStorage.setItem('attachfilepath', this.m_attachfilepath)
      // 检查获取招聘考试信息
      getScanTestPaperInfo({
        rsid: this.m_autoid,
        stationid: sta.stationid,
        username: this.tel //'admin'
      }).then(rs => {
        let data = rs.data[0]
        if (data.test_type_id == 0)
        {
          // 走问卷
          // 判断有没有做过问卷
          if (this.istest == true || this.istest == 'true')
          {
            // 做过就直接进入
            // 简历投递 
            const param = {
              module: this.moduleNo,
              zpacid: this.zpacid,
              tel: this.tel,
              attachfilepath: this.m_attachfilepath,
              autoid: this.m_autoid,
              restype: this.restype,
              tj_empid: this.tj_empid,
              mode: this.mode,
            }
            this.$router.push({
              path: "/seForm",
              query: { param: Base64.encode(JSON.stringify(param)) }
            })
          } else
          {
            // 没做过就要查询是否有问卷，有就做
            getQsTemplateOptionList({ mautoid: sta.autoid }).then(res => {
              if (
                (res.baseinfo.length == 0 && res.data.length == 0) ||
                this.test_before_post == false
              )
              {
                // 表示没有问卷数据
                localStorage.setItem('questionData', JSON.stringify([]))
                //选择岗位
                const station = sta
                  ? sta
                  : {
                    staname: '',
                    stationid: null
                  }
                // 简历投递 
                const param = {
                  module: this.moduleNo,
                  zpacid: this.zpacid,
                  tel: this.tel,
                  attachfilepath: this.m_attachfilepath,
                  autoid: this.m_autoid,
                  restype: this.restype,
                  tj_empid: this.tj_empid,
                  mode: this.mode,
                }
                this.$router.push({
                  path: "/seForm",
                  query: { param: Base64.encode(JSON.stringify(param)) }
                })
              } else
              {
                // 表示有问卷数据，需要跳转到问卷页面
                let qd = {
                  baseinfo: [],
                  data: []
                }
                qd.baseinfo = res.baseinfo
                qd.data = res.data
                localStorage.setItem('questionData', JSON.stringify(qd))
                // 跳转到问卷页面  
                const param = {
                  module: this.moduleNo,
                  restype: this.restype,
                  tel: this.tel,
                  tj_empid: this.tj_empid,
                  istest: this.istest,
                  attachfilepath: this.m_attachfilepath,
                  autoid: this.m_autoid,
                  mode: this.mode,
                }
                this.$router.push({
                  path: "/questionnaire",
                  query: { param: Base64.encode(JSON.stringify(param)) }
                })
              }
            })
          }
        } else
        {
          // 走考试
          checkZpTestRes({
            rsid: this.m_autoid,
            teststyle: '投递'
          }).then(result => {
            if (result.data[0].info == 'N')
            {
              const param = {
                module: this.moduleNo,
                restype: this.restype,
                tel: this.tel,
                tj_empid: this.tj_empid,
                istest: this.istest,
                attachfilepath: this.m_attachfilepath,
                paperid: data.test_paperid,
                mautoid: this.m_autoid,
                teststyle: '投递',
                empid: 0,
                username: this.tel,
                from: 'staList',
                mode: this.mode,
              }
              this.$router.push({
                path: "/examinInfo",
                query: { param: Base64.encode(JSON.stringify(param)) }
              })
            } else
            {
              // 已完成考试就直接走
              // 简历投递 
              const param = {
                module: this.moduleNo,
                zpacid: this.zpacid,
                tel: this.tel,
                attachfilepath: this.m_attachfilepath,
                autoid: this.m_autoid,
                restype: this.restype,
                tj_empid: this.tj_empid,
                mode: this.mode,
              }
              this.$router.push({
                path: "/seForm",
                query: { param: Base64.encode(JSON.stringify(param)) }
              })
            }
          })
        }
      })
    },
    onSearch (val) {
      if (val)
      {
        const list = this.data.filter(e => {
          const staname = e.staname ? e.staname : ''
          const workplace = e.workplace ? e.workplace : ''
          const fulladdr = e.fulladdr ? e.fulladdr : ''
          const degree = e.degree ? e.degree : ''
          return (
            staname.indexOf(val) > -1 ||
            workplace.indexOf(val) > -1 ||
            fulladdr.indexOf(val) > -1 ||
            degree.indexOf(val) > -1
          )
        })
        if (list.length > 0)
        {
          this.groupList = this.changeGroupData(list, 'rctype')
        }
      } else
      {
        this.groupList = this.changeGroupData(this.data, 'rctype')
      }
      if (this.groupList.length > 0)
      {
        this.getTabList(this.groupList[0].name)
      } else
      {
        this.getTabList()
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="less">
.page {
  height: 100vh;
  .gbg {
    background: #e9ebed;
  }
  .pageson {
    height: 100%;
    background: #f5f6fa;
    .hasBackG {
      height: 50vw;
      .register_title {
        height: 8vw;
        font-size: 5vw;
        color: #fff;
        padding: 2vw 0 5vw 0;
        text-align: center;
        // background: #1a8afa;
      }
      .van-search {
        opacity: 0.8;
        background: unset;
        padding: 10vw 40px;
      }
    }
    .op {
      opacity: 1 !important;
    }
    .Sed {
      // width: 84vw;
      height: 12.533vw;
      /* margin: 0 auto; */
      // margin: 5vw auto;
      padding: 4vw;
      background: #fff;
      border-radius: 0.5vw;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 4.8vw;
      letter-spacing: 0.267vw;
      color: #ffffff;
      opacity: 0.4;
      div {
        width: 84vw;
        background-color: #247dff;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 43px;
      }
    }

    .job_content {
      // width: 100%;
      // height: calc(100% - 41vw);
      height: calc(100% - 66vw);
      padding: 2vw;
      .job_box:not(:last-child) {
        margin-bottom: 2vw;
      }
      .job_box {
        border-bottom: 1px solid rgb(233, 233, 233);
        padding: 2vw;
        background: #ffffff;
        box-shadow: 0px 1px 26px 3px rgba(160, 182, 215, 0.05);
        border-radius: 16px;
        .job_head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .staname {
            color: #000;
            font-size: 4.5vw;
            line-height: 9vw;
            font-weight: bold;
          }
          .payface {
            color: #227af4;
            font-size: 4vw;
            line-height: 8vw;
            font-weight: bold;
          }
        }
        .job_body {
          margin-bottom: 10px;
          .fulldeptname {
            font-size: 30px;
            color: red;
          }
          .tg {
            color: #525256;
            font-size: 3.5vw;
            line-height: 7vw;
            span {
              background: #f3f5f7;
              border-radius: 6px;
              margin-right: 3vw;
            }
          }
        }
        .job_foot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .fulladdr {
            font-size: 3.5vw;
          }
          .effectbd {
            color: #a8a8a8;
            font-size: 3vw;
            font-weight: 400;
          }
        }
        .tg {
          color: #626262;
          font-size: 3vw;
          line-height: 6vw;
          span {
            margin-right: 3vw;
          }
        }
        .text-r {
          text-align: right;
        }
      }
    }

    .detail_title {
      /deep/.van-nav-bar__content {
        background-color: #2b8df0;
        .van-nav-bar__left {
          .van-icon {
            color: #ffffff;
            font-size: 5vw;
          }
        }
        .van-nav-bar__title {
          color: #ffffff;
          font-size: 5vw;
          font-weight: bold;
        }
      }
    }
    .van-hairline--bottom::after {
      border-bottom-width: 0;
    }
    .info_box {
      // padding: 10px;
      width: 100%;
      height: calc(100% - 33vw);
      overflow-y: scroll;

      .job-detail-header {
        background: linear-gradient(to bottom, #1a8afa, #f3f4f8);
        padding: 0 3vw;
        // background-color: #fff;
        // border-radius: 1vw;
        // padding: 5vw;
        // font-size: 4vw;
        // line-height: 5vw;
        // box-shadow: 0 1vw 1.2vw 0 rgba(172, 183, 191, 0.5);
        // color: #999;
        .outside_box {
          background: #fff;
          box-shadow: 0px 1px 26px 3px rgba(160, 182, 215, 0.05);
          border-radius: 16px;
          padding: 3vw;
          .staname_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 3vw;
            .staname {
              font-size: 5vw;
              color: #1f1f1f;
              font-weight: bold;
            }
            .pay {
              font-size: 4.5vw;
              color: #227af4;
              font-weight: bold;
            }
          }
        }
        .deptname_box {
          display: flex;
          align-items: center;
          font-size: 3.5vw;
          color: #1f1f1f;
          line-height: 4vw;
          padding-bottom: 2vw;
          margin-bottom: 3vw;
          border-bottom: 1px solid #eeeeee;
          .van-icon {
            margin-right: 1vw;
          }
          .deptname {
            margin-right: 3vw;
          }
        }
        .stop_time_box {
          color: #a8a8a8;
          font-size: 3.5vw;
          line-height: 4vw;
        }
      }
      .job_Description {
        padding: 3vw;
        background-color: #fff;
        margin: 3vw;
        border-radius: 16px;
        box-shadow: 0 1vw 1.2vw 0 rgba(172, 183, 191, 0.5);
        .ch {
          font-size: 4vw;
          color: #43496a;
          line-height: 5vw;
          font-weight: bold;
          margin-bottom: 1vw;
        }
        .title {
          font-size: 3.5vw;
          color: #262626;
          margin-bottom: 1vw;
        }
        .gzzz {
          font-size: 3vw;
          line-height: 1.5;
          color: #262626;
          margin-bottom: 2vw;
          white-space: pre-wrap;
        }
        .rzzg {
          font-size: 3vw;
          line-height: 1.5;
          color: #262626;
          white-space: pre-wrap;
        }
      }
      .job_location {
        padding: 3vw;
        background-color: #fff;
        margin: 3vw;
        border-radius: 16px;
        box-shadow: 0 1vw 1.2vw 0 rgba(172, 183, 191, 0.5);
        .workplace {
          font-size: 4vw;
          color: #1f1f1f;
          margin-bottom: 2vw;
          .van-icon {
            margin-right: 1vw;
          }
        }
        .fulladdr {
          font-size: 3.5vw;
          color: #9b9b9b;
        }
      }
    }
  }
}
</style>
